export const applyFrench = (en, fr) => `select($locale == "fr" => coalesce(${fr}, ${en}), ${en})`;
